import { fromJS } from 'immutable'; // use of immutablejs for various js operations to simplify our work

import * as service from 'services/coachProfile.service';
import {
  REQUESTED,
  FAILED,
  SUCCESSFUL,
  GET_ALL_POSTING_REQUESTED,
  GET_ALL_POSTING_FAILED,
  GET_ALL_POSTING_SUCCESSFUL,
  UPDATE_REQUESTED,
  UPDATE_FAILED,
  UPDATE_SUCCESSFUL,
  DELETE_POSTING_REQUESTED,
  DELETE_POSTING_SUCCESSFUL,
  DELETE_POSTING_FAILED,
  ALL_POSTINGS_CREATED_SUCCESSFUL, CREATE_ALL_POSTINGS_FAILED,
  CREATE_POSTINGS_REQUESTED,
} from './actionTypes';
import { allPositions } from '../../common/constants/postingData';


export function getAllPostings(id) {
  return (dispatch) => {
    dispatch({
      type: GET_ALL_POSTING_REQUESTED,
    });
    service.getAllPostingsById(id)
            .then((result) => {
              if (result) {
                dispatch({
                  type: GET_ALL_POSTING_SUCCESSFUL,
                  data: fromJS(result),
                });
              }
            })
            .catch((err) => {
              dispatch({
                type: GET_ALL_POSTING_FAILED,
                error: err,
              });
            });
  };
}

export function addPostings(data) {
  return (dispatch) => {
    dispatch({
      type: REQUESTED,
    });
    service.storePosting(data)
            .then((result) => {
              dispatch({
                type: SUCCESSFUL,
                postings: fromJS(result),
              });
            })
            .catch((err) => {
              dispatch({
                type: FAILED,
                error: err,
              });
            });
  };
}

// export function getPostingById(id) {
//   return (dispatch) => {
//     dispatch({
//       type: EDIT_POSTING_REQUESTED,
//     });
//     service.editPosting(id)
//         .then((result) => {
//           dispatch({
//             type: EDIT_POSTING_SUCCESSFUL,
//             data: fromJS(result),
//           });
//         })
//         .catch((err) => {
//           dispatch({
//             type: EDIT_POSTING_FAILED,
//             error: err,
//           });
//         });
//   };
// }


export function updatePostings(payload, index) {
  return (dispatch) => {
    dispatch({
      type: UPDATE_REQUESTED,
    });
    service.updatePosting(payload)
            .then((result) => {
              dispatch({
                type: UPDATE_SUCCESSFUL,
                data: fromJS(result),
                index,
              });
            })
            .catch((err) => {
              dispatch({
                type: UPDATE_FAILED,
                error: err,
              });
            });
  };
}


export function deleteposting(id) {
  return (dispatch) => {
    dispatch({
      type: DELETE_POSTING_REQUESTED,
    });
    service.deletePostingById(id)
            .then((result) => {
              if (result) {
                dispatch({
                  type: DELETE_POSTING_SUCCESSFUL,
                  transaction: fromJS(result),
                });
              }
            })
            .catch((err) => {
              dispatch({
                type: DELETE_POSTING_FAILED,
                error: err,
              });
            });
  };
}

export const createAllPostingForThisCollege = (profile, user) => (dispatch) => {
  const positionArray = allPositions[profile.get('division') === 'NJCAA' ? 'JUCO' : profile.get('division')];

  const allPayloads = positionArray.map(item => ({
    coach_id: profile.get('coach_id'),
    posting_title: item.position,
    posting_sport: 'sport',
    team_name: 'teamName',
    coach_name: user.username,
    college_name: profile.get('college'),
    college_id: profile.get('college_id'),
    college_image: 'not found',
    city: profile.get('city'),
    state: profile.get('state'),
    team_page_link: profile.get('team_page_link'),
    question_link: profile.get('question_link'),
    division: profile.get('division') === 'NJCAA' ? 'JUCO' : profile.get('division'),
    posting_status: 'active',
    requirements: {
      min_gpa: profile.get('gpa'),
      min_height: `${item.feet}'${item.inches}`,
      min_weight: item.weight,
      min_t40: item.t40,
    },
    description: item.description || null,
  }));
  dispatch({
    type: CREATE_POSTINGS_REQUESTED,
  });
  Promise.all(allPayloads.map((item => (
    service.storePosting(item)
  )))).then((results) => {
    dispatch({
      type: ALL_POSTINGS_CREATED_SUCCESSFUL,
      postings: fromJS(results),
    });
  })
    .catch((error) => {
      dispatch({
        type: CREATE_ALL_POSTINGS_FAILED,
        error,
      });
    });
};



// WEBPACK FOOTER //
// ./src/components/Postings/actions.js